import React, { FC } from 'react';
import './NavigationLayout.css';
import CircularButton from '../CircularButton/CircularButton';
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { State, actionCreators } from '../../state';
import { AppState, SequenceType, SideMenuState, StepType, TrainingModule } from '../../models';
import { faBars, faArrowLeftLong } from "@fortawesome/free-solid-svg-icons"
import SideMenu from '../SideMenu/SideMenu';
import { Outlet, useNavigate } from 'react-router-dom';
import { trainingForModule } from '../LearninHome/LearninHome';
import LoadingView from '../LoadingView/LoadingView';

interface NavigationLayoutProps {}

const NavigationLayout: FC<NavigationLayoutProps> = () => {
  
  const { appState, sideMenuState, navState, trainingState, loadingState } = useSelector((state: State) => state)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { updateSideMenuState, updateNavState, clearNavState, updateAppState, clearTrainingState, updateTrainingState } = bindActionCreators(actionCreators, dispatch)

  function backPressed() {
    var ns = navState.stack
    if (ns.length === 1) {
      clearNavState()
      updateAppState(AppState.NoAnimation)
      clearTrainingState()
      navigate("/")
    } else {
      ns.pop()
      const prevNsi = ns.slice(-1)[0]
      var ts = trainingState.currentTraining
      if (prevNsi) {
        ts = trainingForModule(prevNsi.trainingModule ?? TrainingModule.Kiosk).currentTraining
        ts!.currentStepIndex = prevNsi.stepNumber ?? 0

        let subModuleIndex = ts!.currentSubModuleIndex
        let useAlternates = false
        if (subModuleIndex < 0) {
            useAlternates = true
            subModuleIndex = Math.abs((subModuleIndex + 1))
        }


        ts!.currentSubModuleIndex = ts!.currentSubModuleIndex
        const prevStep = useAlternates ? ts.alternateModules![subModuleIndex].steps[ts.currentStepIndex] : ts.subModules[ts.currentSubModuleIndex].steps[ts.currentStepIndex]
        if (prevStep.type === StepType.Sequence && prevStep.sequenceInfo!.type === SequenceType.Progress) {
          // previous step was just a progress step, skipping over and going to the previous interactive step
          ts.currentStepIndex = ts.currentStepIndex - 1
          ns.pop()
        }
        updateTrainingState({currentTraining: ts})
      }
      updateNavState({stack: ns})
      if ('path' in prevNsi) {
        navigate(prevNsi.path ?? "/")
      }
    }
  }

  return (
  <>
    <Outlet />
    {appState !== AppState.InitialLoad &&
      <CircularButton 
        iconProp={faBars} 
        onClick={() => {
          if (sideMenuState === SideMenuState.Closed) {
            updateSideMenuState(SideMenuState.Open)
          } else {
            updateSideMenuState(SideMenuState.Closed)
          }
        }} 
        style={{ position: "absolute", top: "14px", left: "16px" }}
      />
    }
    {navState.stack.length > 0 && 
      <CircularButton 
        iconProp={faArrowLeftLong}
        onClick={backPressed}
        style={{ position: "absolute", top: "14px", left: "100px" }}
      />
    }
    <SideMenu />
    {loadingState.loading && <LoadingView />}
  </>
)};

export default NavigationLayout;
